export const iconFontAwesomeMarketingPersonSwimming = (
	<i className="fa-solid fa-person-swimming"></i>
);
